"use client";

import Link from "next/link";
import { Box, Text } from "@chakra-ui/react";
import GenericIcon from "@/shared/ui/actions/GenericIcon";
import { usePathname } from "next/navigation";
import { PublicLink } from "@/shared/public-ui";

interface LogoLinkProps {
  whichNavbar: "public" | "private";
}

export function LogoLinkChakra({ whichNavbar }: LogoLinkProps) {
  const pathname = usePathname();

  const isOnPrivateRoute =
    whichNavbar === "private" ||
    pathname?.startsWith("/studio") ||
    pathname?.startsWith("/backlog");
  const targetHref = "/";
  const linkLabel = isOnPrivateRoute ? "Go to public home" : "Go to home page";

  return (
    <PublicLink
      asChild
      variant="nav"
      aria-label={linkLabel}
      title={linkLabel}
      _hover={{
        color: "moveon.primary",
        textDecoration: "none",
      }}
    >
      <Link href={targetHref}>
        <Text
          as="span"
          fontSize={{
            base: "lg",
            md: "xl",
            lg: "2xl",
          }}
          fontWeight="bold"
          color="moveon.primary"
          css={{ cursor: "pointer" }}
          _hover={{
            color: "moveon.primary",
          }}
          display="flex"
          alignItems="center"
        >
          <Box display={{ base: "block", sm: "none" }}>
            <GenericIcon icon="home_up" />
          </Box>
          <Text as="span" display={{ base: "none", sm: "inline" }}>
            MoveOn
          </Text>
        </Text>
      </Link>
    </PublicLink>
  );
}
